import {refreshDmsDatagrid} from '@dms/shared';

import {JOB_ITEMS_GRID_CODE} from '../../../constants/jobItemsGridCode';
import {ORDER_ITEMS_GRID_CODE} from '../../../constants/orderItemsGridCode';

// The grids that show a service order's items and their prices. None of them is RTK-driven, so cache
// invalidation cannot reach them — anything that writes items into an order has to refresh them.
// OrderCard mounts only the active tab, and a freshly mounted grid fetches anyway, so refreshing an
// unmounted one is a harmless no-op; firing all three is what keeps the open tab correct.
const SERVICE_ORDER_GRID_CODES = [
  ORDER_ITEMS_GRID_CODE,
  JOB_ITEMS_GRID_CODE,
  'service-order-profitability',
] as const;

export const refreshServiceOrderGrids = () =>
  SERVICE_ORDER_GRID_CODES.forEach((gridCode) => refreshDmsDatagrid(gridCode));
